export const zh = {
  form: {
    title: '标题',
    avatarUrl: '头像(可点击放大)',
    operateDate: '操作日期',
    operationType: '操作行为'
  }
}